import DataLayer from "./DataLayer";

export default () => DataLayer.reset();
